
export default {
  props: ["items", "title", "icon", "ver", "check"],
  mounted() {
  }
};
